import { render, staticRenderFns } from "./vendor-integration-history.vue?vue&type=template&id=6ccf20e7&scoped=true&"
import script from "./vendor-integration-history.vue?vue&type=script&lang=js&"
export * from "./vendor-integration-history.vue?vue&type=script&lang=js&"
import style0 from "./vendor-integration-history.vue?vue&type=style&index=0&id=6ccf20e7&lang=scss&scoped=true&"
import style1 from "./vendor-integration-history.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccf20e7",
  null
  
)

export default component.exports